<template>
  <BaseDialog
    title="編輯 GA 串接設定"
    width="610px"
    btn="儲存"
    :btn1Loading="submitting"
    @close="$emit('close')"
    @confirm="handleSubmit"
  >
    <FlexLayout col>
      <BaseElForm ref="formRef" :model="formData" label-position="top">
        <BaseElFormItem label="Google 代碼 ID" prop="googleAnalyticsMeasurementId">
          <BaseElInput v-model="formData.googleAnalyticsMeasurementId" placeholder="請輸入 Google 代碼 ID" />
        </BaseElFormItem>
      </BaseElForm>
      <GrayBlockContainer>
        - <a class="text-primary-100 underline" href="https://support.google.com/analytics/answer/9539598?hl=zh-Hant" target="_blank" rel="noopener noreferrer">[GA4] 如何找到 Google 代碼 ID</a>
      </GrayBlockContainer>
    </FlexLayout>
  </BaseDialog>
</template>

<script>
import { defineComponent, reactive, ref, onMounted } from 'vue'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import { UpdateClientPageConfig } from '@/api/member/memberCenter'
import { useShop } from '@/use/shop'
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'

export default defineComponent({
  name: 'MemberCenterGASettingEditDialog',
  components: {
    BaseDialog,
    GrayBlockContainer,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close', 'refresh'],
  setup (props, { emit }) {
    const { shopId } = useShop()
    const submitting = ref(false)
    const formData = reactive({
      googleAnalyticsMeasurementId: '',
    })

    const handleSubmit = async () => {
      submitting.value = true
      const payload = {
        shopId: shopId.value,
        colorStyle: props.configData.colorStyle ?? undefined,
        CustomColorStyleId: props.configData.CustomColorStyleId ?? undefined,
        enableLiff: props.configData.enableLiff,
        clientShortUrls: props.configData.clientShortUrls ?? undefined,
        googleAnalyticsMeasurementId: formData.googleAnalyticsMeasurementId,
      }

      const [, err] = await UpdateClientPageConfig(payload)
      submitting.value = false
      if (err) {
        window.$message.error(err)
        return
      }
      window.$message.success('更新成功')
      emit('refresh')
      emit('close')
    }

    onMounted(() => {
      formData.googleAnalyticsMeasurementId = props.configData.googleAnalyticsMeasurementId || ''
    })

    return {
      submitting,
      formData,
      handleSubmit,
    }
  },
})
</script>

<style lang="postcss" scoped>
</style>
